// third-party
import { FormattedMessage } from "react-intl";

// assets

import PointOfSaleIcon from '@mui/icons-material/PointOfSale';
import CategoryIcon from '@mui/icons-material/Category';
import ContactPageIcon from '@mui/icons-material/ContactPage';
import enums from 'utils/enums';


// icons
const icons = {
    PointOfSaleIcon, CategoryIcon, ContactPageIcon,
};

// ==============================|| MENU ITEMS - MAIN ||============================== //


// ==============================|| MENU ITEMS - MAIN ||============================== //

const inventory = {
    id: "inventory",
    type: "group",
    title: <FormattedMessage id="inventory" />,
    roleTags: [enums.userRole.CJAdmin, enums.userRole.SuperAdmin],
    children: [
        {
            id: "suppliers",
            title: <FormattedMessage id="suppliers" />,
            type: "item",
            url: "inventory/suppliers",
            icon: icons.ContactPageIcon,
            isShowFilter: true,
            roleTags: [enums.userRole.CJAdmin, enums.userRole.SuperAdmin],
            subTitle: "Manage Suppliers",
            showTitle: true
        },
        {
            id: "ingredients",
            title: <FormattedMessage id="ingredients" />,
            type: "item",
            url: "inventory/components",
            icon: icons.CategoryIcon,
            isShowFilter: true,
            roleTags: [enums.userRole.CJAdmin, enums.userRole.SuperAdmin],
            subTitle: "Manage Components",
            showTitle: true
        },
        {
            id: "posItems",
            title: <FormattedMessage id="posItems" />,
            type: "item",
            url: "inventory/pos-items",
            icon: icons.PointOfSaleIcon,
            isShowFilter: true,
            roleTags: [enums.userRole.CJAdmin, enums.userRole.SuperAdmin],
            subTitle: "Manage POS Items for Ingredients",
            showTitle: true
        },
    ],
};

export default inventory;
